import Badge from 'components/molecules/Badge';
import * as React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectCustomer } from 'redux-stores/slices/authSlice';
import styled from 'styled-components';

const StyledBadge = styled(Badge)`
  background: ${({ theme }) => theme.colors.paleLightGray};
  border-radius: 8px;
  padding: 4px 8px;

  > h5 {
    color: ${({ theme }) => theme.colors.grey100};
    font-size: 12px;
  }
`;

const StyledDiv = styled.div<{ $mode?: 'row' | 'column' }>`
  display: ${({ $mode }) => ($mode === 'row' ? 'unset' : 'flex')};
  flex-direction: ${({ $mode }) => $mode};
  justify-content: center;
  text-align: center;
  gap: ${({ $mode }) => ($mode === 'row' ? '4px' : '0px')};
`;

const CREDITS_TEXT_TOKEN_KEYS = ['newOrderPage.creditsInfoText', 'newOrderPage.creditsInfoValue'];

interface CreditsBadgeProps {
  mode?: 'row' | 'column';
}

const CreditsBadge = ({ mode = 'row' }: CreditsBadgeProps) => {
  const { t } = useTranslation();
  const customer = useSelector(selectCustomer);

  if (!customer || !customer?.credit) return null;

  const CreditsTextTokens = React.useMemo(
    () =>
      CREDITS_TEXT_TOKEN_KEYS.map((i18nKey) => (
        <Trans
          t={t}
          i18nKey={i18nKey}
          values={{ credit: customer?.credit ?? 0 }}
          components={{
            bold: <span className="h5 mb-0" />,
          }}
        />
      )),
    []
  );

  return <StyledBadge content={<StyledDiv $mode={mode}>{CreditsTextTokens}</StyledDiv>} />;
};

export default CreditsBadge;
